var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FeedbackWrapper",
    {
      staticClass: "rounded-sm",
      attrs: {
        loading: _vm.loading,
        noData: !_vm.hasData,
        minHeight: _vm.minHeight,
        title: _vm.title,
        message: "",
        iconName: "",
        titleClass: "az-ds-card-title",
        bordered: ""
      },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function() {
            return [
              _c("div", { staticClass: "d-flex flex-column az-gap-xsmall" }, [
                _c("div", { staticClass: "az-text-secondary text-center" }, [
                  _vm._v(" " + _vm._s(_vm.noDataTitle) + " ")
                ]),
                _c(
                  "div",
                  { staticClass: "az-text-secondary text-sm text-center" },
                  [_vm._v(" " + _vm._s(_vm.noDataDescription) + " ")]
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "generic-donut-chart az-card-bordered" }, [
        _vm.hasData
          ? _c(
              "div",
              { staticClass: "generic-donut-chart__title az-ds-card-title" },
              [_vm._v(" " + _vm._s(_vm.title) + " ")]
            )
          : _vm._e(),
        _c("div", { staticClass: "generic-donut-chart__content" }, [
          _c(
            "div",
            { staticClass: "generic-donut-chart__graph" },
            [
              _c("donut-chart", {
                attrs: {
                  chartData: _vm.chartConfig.data,
                  options: _vm.chartConfig.options,
                  width: _vm.isSmall ? 150 : 375,
                  height: _vm.isSmall ? 150 : 250
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "generic-donut-chart__legends" },
            _vm._l(_vm.legends, function(legend, index) {
              return _c(
                "div",
                { key: index, staticClass: "generic-donut-chart__legend" },
                [
                  _c("div", {
                    staticClass: "generic-donut-chart__legend-color",
                    style: { backgroundColor: legend.color }
                  }),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "span",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "generic-donut-chart__legend-label"
                                    },
                                    on
                                  ),
                                  [_vm._v(" " + _vm._s(legend.label) + " ")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.formatTooltip(legend)))])]
                  )
                ],
                1
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }